import { defineMessages } from 'react-intl';

const messages = defineMessages({
  message0: 'Retro arcade carpet themed decor',
  message1: 'Vintage kittens wearing bows stickers',
  message2: 'Glamorous cowboy boots aesthetic posters',
  message3: 'Pastel pixel gaming landscape totes',
  message4: 'Dragons breathing fire phone cases',
  message5: 'Anime girl eating ramen magnets',
  message6: 'Cyber punk mechanical anatomy posters',
  message7: 'Motivational quotes for athletes stickers',
  message8: 'Vinyl record collector tshirts',
  message9: 'Positive affirmations with aura gradient stickers',
  message10: 'Romantasy for bookish nerds stickers'
});

export const useEngageTextMessaging = intl => {
  return Object.keys(messages).map(key => intl.formatMessage(messages[key]));
};
